export const MAX_PLAYERS = 4
export const MAX_NAME_LENGTH = 16

export const VIBRATION_PATTERN = {
  mismatch: [200]
}
export const VICTORY_SOUND_DELAY = 800
export const END_SCREEN_TRANSITION_DELAY = 1800
